
import type * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "../../lib/utils"

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer data-[state=checked]:bg-primary data-[state=checked]:border-primary-foreground/20 data-[state=unchecked]:bg-gray-300 data-[state=unchecked]:border-gray-500 focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-gray-600 dark:data-[state=unchecked]:border-gray-400 dark:data-[state=checked]:border-primary-foreground/30 inline-flex h-5 w-9 shrink-0 items-center rounded-full border-2 shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 p-0.5 relative",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "bg-white border border-gray-400 dark:bg-gray-200 dark:border-gray-500 data-[state=checked]:bg-white data-[state=checked]:border-gray-300 dark:data-[state=checked]:bg-gray-100 dark:data-[state=checked]:border-gray-400 pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0 shadow-sm",
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
